import tw from "twin.macro";

export const Container = tw.div`
  flex min-h-[450px]
`;
